import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const SectionContainer = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.down('md')} {
    margin-bottom: 24px;
    gap: 16px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

export const SectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #999999;
  margin: 0;

  ${theme.breakpoints.down('md')} {
    color: #999999;
  }
`

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e5e7eb;
`

export const Value = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #262626;

  ${theme.breakpoints.down('md')} {
    font-size: 16px;
    line-height: 24px;
  }
`

export const Badge = styled.div`
  background: #14b8aa;
  color: white;
  padding: 2px 8px;
  border-radius: 100px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 20px;

  svg {
    width: 12px;
    height: 12px;
  }
`

export const DueDate = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  color: #999999;

  ${theme.breakpoints.down('md')} {
    font-size: 12px;
    line-height: 24px;
  }
`

export const ChangeLink = styled.a`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #0273ff;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0052cc;
  }
`

export const MinValueInfo = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666666;
  margin-top: -4px;
`
